import axios from 'axios';
import { useAuthStore } from '@/store/AuthStore';

const axiosInstance = axios.create({
  baseURL: 'https://frigofix.ch/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Intercepteur de réponse
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(error);
  }
);

export default axiosInstance;